import { Outlet } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteSidebar from "./SiteSidebar";
import SiteFooter from "./SiteFooter";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <SiteHeader />
      <div className="flex-1 w-full">
        <div className="mx-auto w-full max-w-[1600px] px-4 md:px-6 py-6 flex flex-col lg:flex-row gap-6 lg:gap-8">
          <SiteSidebar />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}